import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { HiOutlineSwitchHorizontal } from 'react-icons/hi';

import './tabTwoView.scss';
import trashIcon from 'assets/icons/trash.svg';
import add_circle from 'assets/icons/add_circle.svg';
import pencilImage from 'assets/icons/pencil.png';
import WorkingDetailsCard from '../workingDetailsCard/workingDetailsCard';
import { IEmpInfoData, ISchData, ISchDataList, ISchList } from 'types/listOfEmployees';
import { formatNumberValueToKoreanTime, getChangeToKorean, scheduleToMinValue } from 'constants/utils';
import useAlertConfirmStore from 'zustands/useAlertConfirmStore';

interface IProps {
  infoData: IEmpInfoData | null;
  schData: ISchDataList[];
  toggleWorkType: () => Promise<void>;
  removeSch: (deleteSchList: string[]) => Promise<void>;
  managerEditableEmpInfo: boolean;
}
const TabTwoView = ({ infoData, schData, toggleWorkType, removeSch, managerEditableEmpInfo }: IProps) => {
  const navigate = useNavigate();
  // console.log('infoData', infoData);
  // console.log('schData', schData);
  const { setModalState } = useAlertConfirmStore();

  let formatedSch = schData.map((sch) => {
    let allTimeObj: { [key: string]: ISchData[] } = {};
    sch.data.map((i) => {
      const key = `${i.ATTENDANCE_TIME} ~ ${i.WORK_OFF_TIME}`;
      if (Object.hasOwn(allTimeObj, key)) {
        allTimeObj[key].push(i);
      } else {
        allTimeObj[key] = [i];
      }
    });

    const allTimeArr = [];
    for (let key in allTimeObj) {
      allTimeArr.push(allTimeObj[key]);
    }

    return {
      ...sch,
      data: allTimeArr,
    };
  });
  // console.log('formatedSch', formatedSch);

  return (
    <div className="memberViewInfoTabTwo">
      <div className="personalInfo">
        <div className="headingWithSettings">
          <div className="headingDark-type2">근무일정</div>
          {managerEditableEmpInfo && (
            <button
              className="settingsWrapper"
              onClick={() => {
                setModalState({
                  isModalShow: true,
                  title: '근무일정 추가',
                  desc: '기존에 설정된 근무시간, 요일이 아닌 다른 일정으로 근무하기 위해 일정을 "추가"합니다.\n\n* 해당 일정이 잘못된 경우에는 "수정"을 진행해 주세 요. 수정 시 기존 출퇴근, 급여 데이터가 변동 될 수 있 습니다.',
                  okBtnText: '확인',
                  okCallback: () => {
                    navigate('/work-schedule', {
                      state: {
                        empData: infoData,
                        formType: '근무일정추가',
                      },
                    });
                  },
                  isWarning: false,
                });
              }}>
              <img src={add_circle} alt="" className="add_circle" />
              일정추가
            </button>
          )}
        </div>
        <div className="section">
          <div className="label">일하는 방식</div>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
            <div className={infoData?.CALENDAR === '1' ? 'redType' : 'blueType'}>
              {infoData?.CALENDAR === '1' ? '자율출퇴근' : '고정근무'}
            </div>
            {managerEditableEmpInfo && (
              <button
                onClick={toggleWorkType}
                style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', color: '#505054' }}>
                <HiOutlineSwitchHorizontal style={{ marginRight: 3 }} />
                {infoData?.CALENDAR === '1' ? '고정근무 전환하기' : '자율출퇴근 전환하기'}
              </button>
            )}
          </div>
        </div>
      </div>

      {infoData?.CALENDAR === '0' && (
        <>
          {formatedSch.length === 0 ? (
            <div className="scheduleInfo">
              <div className="section">
                <div className="label">일정기간</div>
                <div className="emptyArea" style={{ marginTop: 0 }}>
                  <div className="emptyText">등록된 일정이 없습니다</div>
                </div>
              </div>
            </div>
          ) : (
            formatedSch.map((i: ISchList) => {
              // 수정시 해당 아이템
              const thisSch = formatedSch.find((sch) => sch.START === i.START && sch.END === i.END);
              return (
                <div key={`${i.START}_${i.END}`} className="scheduleInfo">
                  <div className="section">
                    <div className="label">일정기간</div>
                    <div className="value">
                      <div>
                        {moment(i.START).format('YYYY.MM.DD')}
                        {i.END ? ' ~ ' + moment(i.END).format('YYYY.MM.DD') : ' ~ 계속'}
                      </div>
                      {/* {managerEditableEmpInfo && (
                        <div className="menuBtn">
                          <div>
                            <button
                              className="settingsWrapper"
                              onClick={() => {
                                navigate('/work-schedule', {
                                  state: {
                                    empData: infoData,
                                    schData: thisSch,
                                    formType: '근무일정수정',
                                  },
                                });
                              }}>
                              <img src={pencilImage} alt="" className="pencilImage" />
                              수정
                            </button>
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>
                  {i.data.length > 0 && (
                    <div>
                      {i.data.map((j) => {
                        const dayArr: string[] = [];
                        j.map((k) => {
                          // 요일 배열
                          dayArr.push(getChangeToKorean(k.DAY));
                        });

                        return (
                          <WorkingDetailsCard
                            key={`${i.START}_${i.END} ${j[0].ATTENDANCE_TIME} ~ ${j[0].WORK_OFF_TIME}`}
                            days={dayArr.join(', ')}
                            time={`${j[0].ATTENDANCE_TIME} ~ ${j[0].WORK_OFF_TIME}`}
                            hours={formatNumberValueToKoreanTime(
                              scheduleToMinValue(j[0].ATTENDANCE_TIME, j[0].WORK_OFF_TIME),
                            ).toString()}
                            removeBtnText={managerEditableEmpInfo ? '삭제' : ''}
                            modifyBtnText={managerEditableEmpInfo ? '수정' : ''}
                            infoData={infoData}
                            thisSch={thisSch}
                            onRemove={() => {
                              removeSch(j.map((a) => a.EMP_SCH_SEQ));
                            }}
                          />
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })
          )}
        </>
      )}

      <div className="accountInfo">
        <div className="headingWithSettings">
          <div className="headingDark-type2">연차정보</div>
          {managerEditableEmpInfo && (
            <button
              className="settingsWrapper"
              onClick={() => {
                navigate('/work-schedule', {
                  state: {
                    empData: infoData,
                    schData,
                    formType: '연차정보',
                  },
                });
              }}>
              <img src={pencilImage} alt="" className="pencilImage" />
              수정
            </button>
          )}
        </div>

        <div className="section" style={{ marginTop: 5 }}>
          <div className="label">총 연차일</div>
          <div className="grayValue">{infoData?.Annual === 0 ? '정보없음' : infoData?.Annual + '일'}</div>
        </div>
        <div className="section" style={{ marginTop: 5 }}>
          <div className="label">사용 연차</div>
          <div className="grayValue">{infoData?.Annual === 0 ? '정보없음' : infoData?.USE_Annual + '일'}</div>
        </div>
        <div className="section" style={{ marginTop: 5 }}>
          <div className="label">남은 연차</div>
          <div className="grayValue">{infoData?.Annual === 0 ? '정보없음' : infoData?.RemainderAnnual + '일'}</div>
        </div>
        <br />
      </div>
    </div>
  );
};

export default TabTwoView;
